import { AuthWellKnownEndpoints, PassedInitialConfig } from 'angular-auth-oidc-client';

export interface OidcEnvironmentConfig {
  authority: string;
  clientId: string;
  redirectUrl: string;
  silentRenewUrl: string;
  postLogoutRedirectUri: string;
  scope: string;
  reloginCallbackUrl?: string;
  /**
   * Provide well-known endpoints statically instead of fetching them from the discovery URL.
   * Required for local development where the auth server is on a different origin
   * and does not have CORS configured for localhost.
   */
  wellKnownEndpoints?: AuthWellKnownEndpoints;
  strictIssuerValidationOnWellKnownRetrievalOff?: boolean;
}

export function buildAuthConfig(env: { oidcConfig: OidcEnvironmentConfig }): PassedInitialConfig {
  const cfg = env.oidcConfig;
  return {
    config: {
      authority: cfg.authority,
      clientId: cfg.clientId,
      redirectUrl: cfg.redirectUrl,
      postLogoutRedirectUri: cfg.postLogoutRedirectUri,
      scope: cfg.scope,
      responseType: 'code',
      silentRenew: true,
      silentRenewUrl: cfg.silentRenewUrl,
      renewTimeBeforeTokenExpiresInSeconds: 60,
      tokenRefreshInSeconds: 15,
      useRefreshToken: true,
      ignoreNonceAfterRefresh: true,
      autoUserInfo: false,
      authWellknownUrlSuffix: '/connect/.well-known/openid-configuration',
      ...(cfg.wellKnownEndpoints && { authWellknownEndpoints: cfg.wellKnownEndpoints }),
      ...(cfg.strictIssuerValidationOnWellKnownRetrievalOff && { strictIssuerValidationOnWellKnownRetrievalOff: true }),
    },
  };
}
